import type { FaireProductEntity } from "../../entity_types/product";

export const p_kk769yjp89: FaireProductEntity = {
  token: "p_kk769yjp89",
  type: "product",
  name: "Pomegranate Limeade Non-Alc Kombucha",
  brandToken: "b_s2jesyk5p9",
  brandName: "Walker Brothers",
  imageUrl: "https://cdn.faire.com/fastly/be692d885510a907323d489b4a5cf1fea923d7af9cfe4b6b1cb3b896d8f6d272.png",
  galleryImageUrls: [],
  priceDollars: 2.25,
  description: "Pomegranate Limeade is our newest limited-release non-alc kombucha made in collaboration with YAFO Kitchen restaurants. Pomegranate and lime juices blend with our house kombucha for a bright, sweet and zesty beverage.\n\nPlease note: This item is unpasteurized, raw kombucha and must be kept refrigerated.\n\nIngredients: Raw Kombucha (Filtered Water, Kombucha Culture, Black Tea*, Green Tea*, Jasmine Tea*, Cane Sugar*), Pomegranate Juice, Lime Juice*, *=certified organic ingredients\n\nWalker Brothers craft kombucha is non-alcoholic, rich in live probiotics, gluten-free, and vegan.\n\nPackaged in an aluminum can for ease of recycling\n\nA healthy, non-alcoholic option for fall gatherings, tailgates, Halloween, Thanksgiving, Friendsgiving and holiday parties! A great mixer for drinks as well as a good snack pairing with chips and popcorn. ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:41.675Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
